export default __webpack_public_path__ + "media/youtube.86e36a0f.svg";